"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _util = require("../../../util");
var _base = _interopRequireDefault(require("../texts/base"));
var _icon = _interopRequireDefault(require("./icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  if (typeof document === "undefined") {
    return;
  }
  var styles = "@charset \"UTF-8\";\n.pf-buttons.pf-buttons__secondary {\n  border-radius: 5px;\n}\n\n@media (min-width: 320px) {\n  .pf-radio {\n    font-family: \"Neue Haas Grotesk Text Regular\", \"Helvetica Neue\", helvetica, arial, sans-serif;\n    font-size: 16px;\n    line-height: 24px;\n  }\n}\n@media (min-width: 1024px) {\n  .pf-radio {\n    font-size: 18px;\n    line-height: 28px;\n  }\n}\n.pf-radio.pf-radio__button label > span {\n  font-weight: 700;\n  color: #113b5e;\n  font-size: 14px;\n  line-height: 22px;\n  position: relative;\n}\n@media (min-width: 1024px) {\n  .pf-radio.pf-radio__button label > span {\n    font-size: 16px;\n    line-height: 24px;\n  }\n}\n.pf-radio.pf-radio__button label > span:last-child {\n  margin-left: 14px;\n}\n.pf-radio.pf-radio__button label > span:last-child > p {\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 400;\n  color: #113b5e;\n  margin-top: 0;\n}\n@media (min-width: 1024px) {\n  .pf-radio.pf-radio__button label > span:last-child > p {\n    font-size: 14px;\n    line-height: 18px;\n  }\n}\n\n.pf-radio__supplemental-text {\n  font-weight: 400;\n}\n.pf-radio .pf-radio__propulsion-radio {\n  margin-right: 14px;\n}\n@media (min-width: 1024px) {\n  .pf-radio .pf-radio__propulsion-radio {\n    padding-top: 0;\n  }\n}\n.pf-radio input + span {\n  height: 20px;\n  width: 20px;\n  margin-top: 10px;\n}\n.pf-radio.pf-radio__button.pf-radio__button__no-sub-text input + span {\n  margin-top: 0;\n}\n\n.pf-tooltip {\n  padding-top: 2px;\n}\n@media (min-width: 320px) {\n  .pf-tooltip {\n    font-family: \"Neue Haas Grotesk Text Regular\", \"Helvetica Neue\", helvetica, arial, sans-serif;\n    font-size: 12px;\n    line-height: 16px;\n  }\n}\n@media (min-width: 1024px) {\n  .pf-tooltip {\n    font-size: 14px;\n    line-height: 20px;\n  }\n}\n@media (min-width: 1280px) {\n  .pf-tooltip {\n    padding-top: 4px;\n  }\n}\n\n.custom-popper {\n  top: -10px !important;\n}\n.custom-popper .custom-tooltip {\n  background-color: #345a66;\n  width: 258px;\n  min-height: 112px;\n  padding: 0;\n}\n.custom-popper .custom-tooltip .custom-arrow {\n  color: #345a66;\n}\n.custom-popper .custom-tooltip .wrapper.pf-texts {\n  position: relative;\n  display: inline-block;\n  padding: 24px 26px 24px 24px;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.close::before {\n  content: \"\u2715\";\n}\n\n.close {\n  position: absolute;\n  top: 13.33px;\n  right: 13.33px;\n  cursor: pointer;\n  background-color: transparent;\n  border-color: transparent;\n  border: 0;\n  padding: 0;\n}";
  var fileName = "tooltip__styles_3858b66b-663a-4bb5-892f-e7db9fb95fcd";
  var element = document.querySelector("style[data-sass-component='tooltip__styles_3858b66b-663a-4bb5-892f-e7db9fb95fcd']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var BLOCK_CLASS = 'pf-tooltip';
var Tooltip = function Tooltip(_ref) {
  var className = _ref.className,
    title = _ref.title;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showTooltip = _useState2[0],
    setShowTooltip = _useState2[1];
  var handleChange = function handleChange(value) {
    setShowTooltip(value && !showTooltip);
  };
  var classes = {
    tooltip: 'custom-tooltip',
    popper: 'custom-popper',
    arrow: 'custom-arrow'
  };
  var popperRef = (0, _react.useRef)();

  // (Only mobile) Ability to close on click away from the tooltip.
  (0, _react.useEffect)(function () {
    if (window.innerWidth <= 768) {
      var handleClick = function handleClick(e) {
        if (popperRef && popperRef.current) {
          var _e$target;
          if (!popperRef.current.contains(e.target) && ((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.alt) !== 'circled-question') {
            handleChange();
          }
        }
      };
      document.addEventListener('click', handleClick);
      return function () {
        return document.removeEventListener('click', handleClick);
      };
    }
  }, []);
  return title ? /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    onClick: handleChange,
    className: (0, _util.addClassNames)(className, BLOCK_CLASS),
    classes: classes,
    title: /*#__PURE__*/_react.default.createElement("div", {
      ref: popperRef
    }, /*#__PURE__*/_react.default.createElement(_base.default, {
      className: "wrapper"
    }, title, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "aria-label": "Close",
      onClick: handleChange,
      onKeyDown: handleChange,
      className: "close"
    }))),
    open: showTooltip,
    placement: "bottom",
    interactive: true,
    arrow: true
  }, /*#__PURE__*/_react.default.createElement(_icon.default, null)) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.addClassNames)(className, BLOCK_CLASS)
  });
};
Tooltip.propTypes = {
  className: _propTypes.default.string,
  title: _propTypes.default.string
};
Tooltip.defaultProps = {
  className: '',
  title: ''
};
var _default = exports.default = Tooltip;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');